import axios from "axios";
import { apiAddress } from "../../config/server";
import { ImportType } from "../../types/imports/ImportType";
import { IImport } from "../../types/imports/import";
import { ApiBase } from "./baseApi";

export default class ImportsApi extends ApiBase {
  static ImportApiBase = `${apiAddress}/api/import/`;

  static GetMyImportsApiAddress = ImportsApi.ImportApiBase;

  static CsvImportsAddress = `${ImportsApi.ImportApiBase}csv/`;

  static getMyImports(): Promise<[IImport]> {
    return axios.get(this.GetMyImportsApiAddress).then((response) => {
      if (response.status == 200 && response.data.success) {
        return response.data.data;
      }
      throw new Error(response.data.message);
    });
  }

  static triggerImport(
    importId: string,
    mapping: object | null,
  ): Promise<IImport> {
    return ImportsApi.post<IImport>(
      `${ImportsApi.ImportApiBase + importId}/trigger`,
      { mapping },
    ).then((response) => {
      if (!response.data || !response.data.success)
        throw new Error(response.data.error || "An unknown error occurred");
      if (!response.data.data)
        throw new Error("No data was present on the transport object");
      return response.data.data;
    });
  }

  static triggerPlayHQImport(associationId: string): Promise<IImport> {
    return ImportsApi.post<IImport>(
      `${ImportsApi.ImportApiBase}playhq/${associationId}`,
      {},
    ).then((response) => {
      if (!response.data || !response.data.success)
        throw new Error(response.data.error || "An unknown error occurred");
      if (!response.data.data)
        throw new Error("No data was present on the transport object");
      return response.data.data;
    });
  }

  static queueImport(
    file,
    options: {importType: ImportType,      associationId: string | null, importOldGames: boolean} ,
    uploadProgress: (number) => void,
  ): Promise<IImport> {
    const formData = new FormData();
    const { importType, associationId, importOldGames } = options;
    formData.append("file", file);

    const config = {
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total,
        );
        uploadProgress(percentCompleted);
      },
    };

    return new Promise((resolve, reject) => {
      const q: {[key: string] : any} = {
        associationId,
      }
      if (importOldGames) {
        q.importOldGames = true
      }

      const queryParams = ImportsApi.prepareQueryParams(q);



      const url = this.CsvImportsAddress + importType + queryParams;
      axios
        .post(url, formData, config)
        .then((response) => {
          if (response.data && response.data.success)
            resolve(response.data.data);
          else reject(new Error("An unknown error occurred"));
        })
        .catch((er) => {
          if (er.response && er.response.data && er.response.data.message) {
            er.message += `: ${er.response.data.message}`;
          }
          reject(er);
          throw er;
        });
    });
  }
}
